var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[_c('core-gamename',{staticClass:"name",attrs:{"game":_vm.item.game,"collection":_vm.item.collection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }